module.exports = __webpack_public_path__ + "img/588x310-01.53392789.png";